import React from 'react';
import { useSelector } from 'react-redux';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useTranslation } from 'react-i18next';
import PrivateFillIcon from '@wix/da-ds/pkg/Icons/24x24/PrivateFill';
import { PapiDeviation } from '@wix/da-papi-types';
import PrivateIcon from '@wix/da-ds/pkg/Icons/24x24/Private';
import {
  BiContextProvidedValue,
  BiData,
  PopupClickAddToPrivateCollectionBiEvent,
} from '@wix/da-bi/pkg/events';
import ActionBarIcon from '../../../_partials/ActionBarIcon';
import ActionBarButton from '../../../_partials/items/ActionBarButton';
import ActionBarButtonRestricted from '../../../_partials/ActionBarButtonRestricted';
import { NotificationType } from '../../../../Notifications';
import { getIsPrivatelyCollected } from '../../../../CollectionPanel/redux/selectors';
import { CollectionStoreState } from '../../../../CollectionPanel';

export interface Props {
  deviation: PapiDeviation;
  onClick: () => void;
}

const AddToPrivateCollectionButton: React.FC<Props> = ({ deviation, onClick }) => {
  const { t } = useTranslation();
  const isPrivatelyCollected = useSelector(state =>
    getIsPrivatelyCollected(state as CollectionStoreState, deviation)
  );

  const tooltip = t('comment.action.addToPrivate.tooltip');

  const button = (
    <ActionBarButton
      onClick={onClick}
      aria-label={tooltip}
      biData={BiData<PopupClickAddToPrivateCollectionBiEvent>({
        evid: 334,
        creatorid: BiContextProvidedValue,
        sectionname: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
      })}
    >
      <ActionBarIcon icon={isPrivatelyCollected ? PrivateFillIcon : PrivateIcon} />
    </ActionBarButton>
  );

  return (
    <ActionBarButtonRestricted
      loggedInOnly
      restrictedActionName={ReferralType.ADD_TO_PRIVATE_COLLECTION}
      deviation={deviation}
      tooltip={tooltip}
      notificationTypes={[NotificationType.CollectPrivate]}
      button={button}
    />
  );
};
AddToPrivateCollectionButton.displayName = 'AddToPrivateCollectionButton';

export default AddToPrivateCollectionButton;
